import axios from 'axios'

export default class Area {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/meuUsuario/logout`
    this.tokenBearer = tokenBearer
  }

  exit () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
